import React from 'react';
import { Route } from 'react-router';
import { compose, withStateHandlers, lifecycle } from 'recompose';
import { Helmet } from 'react-helmet';
import { withTranslation } from '../Common/Translations'
import { ephotobookPreviewMetadata } from '../Common/Providers/EPhotobookApi';
import { showErrorMsg } from '../Common/ErrorMsg';
import querystring from 'query-string';
import isEmpty from 'lodash/isEmpty';
import FlipBookContainer from '../Account/EPhotobook/FlipBookContainer';

const metadata = {
  title: 'Share It',
  metaDescription: 'Browse your Share It now',
  meta: {
    charset: 'utf-8',
    name: 'robots',
    content: 'noindex, nofollow'
  }
};

const enhance = compose(
  withTranslation('ephotobook'),
  withStateHandlers({
    previewMetadata: {}
  }, {
    setPreviewMetadata: () => data => ({ previewMetadata: data })
  }),
  lifecycle({
    componentDidMount() {
      const {
        setPreviewMetadata,
        location: {
          search = ''
        } = {}
      } = this.props;

      const {
        file = ''
      } = querystring.parse(search);

      ephotobookPreviewMetadata(querystring.stringify({file}))
        .done(response => setPreviewMetadata(response.data))
        .fail(({ responseJSON: { errors = '' } }) => {
          showErrorMsg(errors);
        });
    }
  })
);

const Container = (props) => {
  const {
    previewMetadata: {
      title = '',
      previewImage = '',
      ownerName = '',
      store = '',
      url = ''
    } = {},
    t
  } = props;

  const description = t("ephotobook.ephotobook_preview_metadata_description",
    `${ownerName} must think you’re really special to them, as they have shared their ePhotobook with you. Check it out here and let them know what you think.`,
    {"name": ownerName}
  );

  return (
    <div>
      { !isEmpty(props.previewMetadata) &&
        <Helmet>
          <meta property="og:title" content={title} />
          <meta property="og:image" content={previewImage} />
          <meta property="og:url" content={url}/>
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content={store} />
          <meta property="og:description" content={description} />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      }
      <FlipBookContainer {...props} />
    </div>
  );
}

const EPhotobookRoute = (
  <Route label="Browse Share It"
         path="ephotobook/preview"
         helmet={metadata}
         components={enhance(Container)}
  />
);

export default EPhotobookRoute;



// WEBPACK FOOTER //
// ./src/Routes/EPhotobook.js